<script setup lang="ts">
import EmployeeService from '~/services/EmployeeService'

/**
 * [{"id":1,"first_name":"Jelle","last_name":"van Outheusden","function":"Sales Representative","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/staging\/images\/1106\/blob"},{"id":6,"first_name":"Ga\u00ebtan","last_name":"Lequeu","function":"Responsable Commercial France","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/production\/images\/1155\/blob"},{"id":9,"first_name":"Geoffrey","last_name":"Toubeau","function":"Sales Representative Wallonnie & Luxembourg","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/production\/images\/1165\/test"},{"id":10,"first_name":"Lydia","last_name":"Garc\u00eda Burgos","function":"Sales & Management Assistant","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/production\/images\/1166\/test"},{"id":11,"first_name":"Raf","last_name":"Lambrigts","function":"Magazijnverantwoordelijke \/ Interne Preventie Adviseur (IPA)","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/live\/images\/1274\/test"},{"id":12,"first_name":"Simon","last_name":"Dreesen","function":"Proces- en datamanagement","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/live\/images\/1275\/test"},{"id":13,"first_name":"Edwin","last_name":"Lips","function":"CEO","public_email":null,"public_phone":null,"image":"https:\/\/giardino.ams3.digitaloceanspaces.com\/\/live\/images\/1353\/test"}]
 */

// "id": 36,
// "first_name": "Rudi",
// "last_name": "Petit-Jean",
// "function": "CEO",
// "public_email": "rudi.petit-jean@giardino-online.com",
// "public_phone": "+32 (0)89 510 360",
// "image": "https://giardino.ams3.digitaloceanspaces.com/v2/live/employee/image/01HNJ0BHGFF3Z1C0QDFF3ATVTG.jpg"

const { t } = useI18n()
export interface TeamEmployee {
  id: number
  first_name: string
  last_name: string
  function: string
  public_email: string
  public_phone: string
  image: string
}

export interface TeamCategory {
  id: number
  title: string
  employees: TeamEmployee[]
}

const response = await EmployeeService.getEmployees() as { data: TeamCategory[] }
const employeesCategories = ref(response.data)

useHead({
  title: t('team.page_description'),
})
</script>

<template>
  <div class="container mx-auto px-2">
    <Curls class="-z-1 absolute inset-y-0 right-0 max-w-[740px]" :variant="2" />
    <h1 class="font-family-interstate text-secondary mx-auto text-center text-6xl font-bold py-8">
      {{ t('team.page_title') }}
    </h1>
    <p class="mb-8 text-2xl font-bold text-center">
      {{ t('team.page_description') }}
    </p>

    <div class="flex flex-wrap justify-center gap-4 mb-8">
      <div v-for="employeesCategory in employeesCategories" :key="employeesCategory.id">
        <div class="flex flex-col gap-4">
          <div class="flex items-center gap-4">
            <h2 class="text-2xl font-bold flex-none">
              {{ employeesCategory.title }}
            </h2>
            <div class="w-full h-px bg-gradient-to-r from-primary/50 to-background" />
          </div>

          <div class="grid lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
            <EmployeeCard v-for="employee in employeesCategory.employees" :key="employee.id" :employee="employee" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.font-family-interstate {
  font-family: interstate, sans-serif;
  font-style: normal;
}
</style>
